import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, SecureInnerPagesGuard } from '@guards/index';
import { NotFoundPage } from '@pages/not-found';


const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/authorized/authorized.module').then(m => m.AuthorizedModule)
  },
  {
    path: 'user',
    data: { breadcrumb: 'User' },
    canActivate: [SecureInnerPagesGuard],
    loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule)
  },
  { 
    path: '404', 
    component: NotFoundPage
  },
  { 
    path: '**', 
    redirectTo: '/404' 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
